module.exports = __webpack_public_path__ + "static/map-arrows-19fc11f85648dbe045fb8d03398506cf.png";